// extracted by mini-css-extract-plugin
export var videoBackground = "background-video-module--video-background--1feMt";
export var videoBackgroundMain = "background-video-module--video-background-main--335C1";
export var videoForeground = "background-video-module--video-foreground--1hZWY";